// states/useGalleryState.js
import { useState } from "react";

export const useGalleryVideoState = () => {
  const [activeTab, setActiveTab] = useState("all");
  const [selectedMedia, setSelectedMedia] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [filterMatch, setFilterMatch] = useState("all");
  const [galleryData, setGalleryData] = useState([]);
  const [loading, setLoading] = useState(true);

  return {
    activeTab,
    setActiveTab,
    selectedMedia,
    setSelectedMedia,
    searchTerm,
    setSearchTerm,
    filterMatch,
    setFilterMatch,
    galleryData,
    setGalleryData,
    loading,
    setLoading
  };
};